import { SITE_URL } from '../../constants'
import { buildCaseStudySchema } from '../../builders/caseStudy'
import { PageMeta } from '../../types'

const description = "国内シェアNo.1のファイル転送ミドルウェア「HULFT」のユーザー世代交代に備え、エキスパートレビュー・NPS調査・ユーザーインタビュー・プロトタイプ検証を実施。若年層のリアルな声を根拠に、製品の次世代UX方針を明確化したセゾンテクノロジーのUX改善事例です。"

const primaryImage = "https://www.i3design.jp/images/img/cases/hulft/ogp_hulft.png"

export const hulftPageMeta: PageMeta = {
  title: "国内No.1ミドルウェアHULFTのUX刷新｜エキスパートレビューとZ世代対応の事例 | i3DESIGN",
  description,
  keyword: "事例,実績,HULFT,ハルフト,UIUX改善",
  image: primaryImage,
  url: `${SITE_URL}/cases/hulft/`,
}

export const hulftSchema = buildCaseStudySchema({
  slug: "hulft",
  pageTitle: hulftPageMeta.title,
  description: hulftPageMeta.description,
  headline: "UX/UI刷新で顧客離れを防止、若年層にも支持されるミドルウェア設計",
  alternativeHeadline: "株式会社セゾンテクノロジー",
  primaryImage,
  images: ["https://www.i3design.jp/images/img/cases/hulft/ogp_hulft.png","https://www.i3design.jp/images/img/cases/hulft/mv.webp"],
  clientName: "株式会社セゾンテクノロジー",
  breadcrumbLabel: "UX/UI刷新で顧客離れを防止、若年層にも支持されるミドルウェア設計",
})
